module.exports = __webpack_public_path__ + "media/AUDIO 05.4b98bb20.mp3";